export const availableCurrencies = [
    {vs_currency: "usd", full_name: "US Dollar", symbol: "$"},
    {vs_currency: "eur", full_name: "Euro",  symbol: "€"},
    {vs_currency: "gbp", full_name: "Pound",  symbol: "£"},
    {vs_currency: "cny", full_name: "Chinese Yuan",  symbol: "￥"},
    {vs_currency: "cad", full_name: "Canadian Dollar",  symbol: "$"},
    {vs_currency:"inr", full_name: "Indian Rupee",  symbol: "₹"},
    {vs_currency: "jpy", full_name: "Japanese Yen",  symbol: "￥"}
]